import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components';
import { showToast } from 'Core/redux/toast/slice';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { selectStatuses } from 'Core/redux/status/selectors';
import { useTransformOptions } from 'Core/hooks';
import { addPart, editPart, actions as partActions } from './store/slice';
import PartAddEditForm from './partmasters-add-edit-form';
import { selectedProduct } from './store/selectors';

const { setProduct } = partActions;

const PartAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const dispatch = useDispatch();
  const partData = useSelector(selectedProduct);
  const [formData, setFormData] = useState(partData || null);
  const [partsData, setPartsData] = useState(partData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(partData?.partPickTickets || []);
  const [filesData, setFilesData] = useState(partData?.shippingDocuments || []);
  const [loading, setLoading] = useState(true);
  const [currentToast, setCurrentToast] = useState(null);

  const isEditMode = Boolean(partData?.id);

  const statuses = useSelector(selectStatuses);
  const statusesOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const onChangesCustomersForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    dispatch(setProduct(null));
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <div className="col-12 px-lg-5">
          <PartAddEditForm data={formData} onChanges={onChangesCustomersForm} />
        </div>

      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? ['changed', 'confirmPickTicketScan', 'customerIdExt', 'isDeleted', 'partIdExt', 'userIds'] : ['partIdExt', 'customerIdExt', 'id', 'userId'];
    if (!formData || Object.keys(formData).some((key) => {
      console.log(key, !ignoreKeys.includes(key), !formData[key],'isEditMode : '+isEditMode)
      return !ignoreKeys.includes(key) && !formData[key]
    })) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {
    const onSave = () => {
      const payload = {
        ...formData,
        userId: localStorage.getItem('UserId')
      };
      console.log(payload)
      if (valid()) {
        const payload = {
          ...formData,
          userId: localStorage.getItem('UserId')
        };
        console.log(payload)
        if (isEditMode) {
          dispatch(editPart(payload));
        } else {
          dispatch(addPart(payload));
        }
      }
    };

    return (
      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Part"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="part-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Part Details' : 'Add Part'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

PartAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Part),
  onCloseModal: PropTypes.func,
};

export default AppModal(PartAddEdit);
